var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game-health"},[_c('div',{staticClass:"game-close-btn-wrap"},[_c('div',{staticClass:"game-close-btn",on:{"click":function($event){return _vm.closeGamePopup('close')}}},[_vm._v("關閉遊戲")])]),_vm._v(" "),_c('iframe',{attrs:{"src":_vm.iframeLink,"frameborder":"0","width":"100%","height":"100%"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-961fca1e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/beautiful-chat/Moneyudn.vue
// module id = null
// module chunks = 